export default __webpack_public_path__ + "static/media/profile.4947dc97.png";